import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../core/actions/actions';
import './IAQSensorData.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import { formatMessage } from '../../translations/connectedIntlProvider';
import Loader from '../../shared/components/Loader/Loader';
import Grid from '../../shared/components/Grid/Grid';
import IState from '../../core/models/IState';
import Pagination from '../../shared/components/Grid/Pagination';
import IPageInfo from '../../models/IPageInfo';
import sensorIcon from '../../assets/Images/sensor32.png';
import RoutesConstants from '../../shared/components/Routes/routes.constants';
import AddIAQSensorColumnPopupHOC from './hoc/AddIAQSensorColumnPopupHOC';
import AddIAQSensorColumn from './IAQAddSensorColumn';
import modelEnum from '../../constants/model.enum';
import IPageLimit from '../../models/IPageLimit';
import userSettingEnum from '../../constants/userSetting.enum';
import { toast } from 'react-toastify';
import DownloadSensorPopupHOC from '../Sensor/hoc/DownloadSensorPopupHOC';
import useWindowDimensions from '../../helpers/windowResize.helper';
import { allIAQSensorData } from '../../core/selectors/iaqsensorData.selector';
import backIcon from '../../assets/Images/Back_16.png';
import IAQSensordataDownloadSensor from './IAQSensorDataDownloadSensor';
import NoDataComponent from '../../shared/components/NoData/NoDataComponent';
import SensorIcon from '../../assets/Images/icon/svg/sensor-icon.svg'

const IAQSensorData = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const iccid = props.location.state ? props.location.state.iccid : '';
  const model = props.location.state ? props.location.state.model : '';
  const pager: IPageLimit = useSelector((state: IState) => { return state.pager });
  const language = useSelector((state: IState) => { return state.preferences.language });
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [columnArr, setColumnArr] = useState<any>([]);
  const { columnLists }: any = useSelector((state: IState) => { return state.column });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false
  });

  const [sensorLocation, setSensorLocation] = useState<any>({
    iccid: '',
    model: '',
    building: '',
    floor: '',
    location: '',
    customerId:'',
    room:''
  });


  let paginationData = {
    CurrentPage: 1,
    PageSize: 10,
    OrderBy: 'desc',
    ICCID: '',
    Model: '',
  }
  const getModePrefix = () =>{
    return modelEnum.IAQ.toLowerCase();
  }
  
  let modePrefix = getModePrefix();

  const { height, width } = useWindowDimensions();

  var dataheading = document.getElementById('data-heading');
  
  var windowHeight = width>767? {
    maxHeight: height - 96 - (dataheading == null ? 0 : dataheading.clientHeight)
  }:{
    maxHeight: height - 140 - (dataheading == null ? 0 : dataheading.clientHeight)
  };


  const dispatch = useDispatch();
  const { sensorDataList }: any = useSelector((state: IState) => { return state.iaqSensorData });
  const allSensorsData: any = useSelector(allIAQSensorData);

  const GetSensorData = () => {
    paginationData.CurrentPage = pageInfo.currentPage;
    paginationData.PageSize = pager.pageLimit;
    paginationData.Model = model;
    paginationData.ICCID = iccid;
    if(paginationData.ICCID)
      dispatch(actions.getIAQSensorData(paginationData));
    dispatch(actions.resetGetSensorByIdState());
  }

  const getSensorColumns = () =>{
    dispatch(actions.getUserSetting(userSettingEnum.SensorColumnIAQ));
  }
  useEffect(() => {
    dispatch(actions.resetGetIAQSensorDataChartState());
    dispatch(actions.resetUserSettingState());
    dispatch(actions.getPageLimit());
    if(props.location.state)
    setSensorLocation({
        ...sensorLocation,
        iccid: props.location.state?.iccid,
        model: props.location.state?.model,
        building: props.location.state?.building,
        location: props.location.state?.location,
        floor: props.location.state?.floor,
        customerId:props.location.state?.customerId,
        room:props.location.state?.room

      });
    getSensorColumns();
    // if (model.toLowerCase() === modelEnum.AQS.toLowerCase()) {
    //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnAQS));
    // } else {
    //   dispatch(actions.getUserSetting(userSettingEnum.SensorColumnFDS));
    // }
    //GetSensorData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setIsRefreshPage = ()=>{
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  }


  useEffect(() => {
    if (columnLists.success && columnLists.loading === false) {
      if (columnLists.columns.Value) {
        setColumnArr(JSON.parse(columnLists.columns.Value));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnLists.success]);

  // useEffect(() => {
  //   refreshSensorDataClickHandler();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [language])


  const onPageLimitChanged = (evt: any) => {
    let pages: number
    pages = props.data && Math.ceil(props.data.length / evt.target.value)
    setPageInfo({ ...pageInfo, currentPage: 1, totalPages: pages, isPagerChange: false });
    dispatch(actions.updatePagerPageLimit(evt.target.value));
  }

  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
    //GetSensorData();
  }

  const downloadSensorClickHandler = () => {
    props.downloadSensorToggleHandler();
  }

  const gotoChartClickHandler = () => {
    dispatch(actions.resetUserSettingState());
    props.history.push({
      pathname: RoutesConstants.IAQSensorDataChart,
      state: {
        iccid: iccid,
        model: model,
        building: props.location.state?.building,
        location: props.location.state?.location,
        floor: props.location.state?.floor,
        customerId:props.location.state?.customerId,
        room:props.location.state?.room,
        latestPayloadTime:props.location.state?.latestPayloadTime,
        fromPath: RoutesConstants.IAQSensorData,
        fromParentPath:props.location.state?.fromParentPath
      }
    });
  }

  const refreshSensorDataClickHandler = () => {
    GetSensorData();
  }

   const backToSensorDataHandler = () => {
        dispatch(actions.resetUserSettingState());
        dispatch(actions.resetGetIAQSensorDataChartState());
        props.history.push({
            pathname: RoutesConstants.IAQRealTimeView,
            state: {
                iccid: iccid,
                model: model,
                building: props.location.state?.building,
                location: props.location.state?.location,
                floor: props.location.state?.floor,
                customerId:props.location.state?.customerId,
                room:props.location.state?.room,
                latestPayloadTime:props.location.state?.latestPayloadTime,
                fromPath: RoutesConstants.IAQSensorData,
                fromParentPath:props.location.state?.fromParentPath
            }
        });
    }

  useEffect(() => {
    if (pager.isPageLimitLoaded) {
      GetSensorData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pager.isPageLimitLoaded, pager.pageLimit]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      GetSensorData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (sensorDataList.success && sensorDataList.datas !== undefined) {
      setPageInfo({ ...pageInfo, totalPages: sensorDataList.datas.TotalPages });
      setDisablePagination(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sensorDataList.success])

  useEffect(() => {
    if (sensorDataList.error != null)
      toast.error(formatMessage(sensorDataList.error));
      dispatch(actions.resetGetIAQSensorDataState());
  }, [sensorDataList.error]);

  const openAddColumn = (row: any, isDeleteParam: boolean) => {
    props.addSensorColumToggleHandler();
  }

  const onColumnSave = () => {
    getSensorColumns();
  }

  const isHidden = (columnName: string) => {
    const isColumnFound = columnArr.includes(columnName);
    return !isColumnFound;
  }

const iaqcolumns: any[] = [{
    dataField: 'Id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('iccid'),
    headerClasses: 'iccid-col',
    hidden: true
  },
  {
    dataField: 'CreateTime',
    text: formatMessage('createtimestamp')
  }, 
  {
    dataField: 'Temprature',
    text: formatMessage(modePrefix+'temprature'),
    hidden: isHidden('temprature')
  },
  {
    dataField: 'Humidity',
    text: formatMessage(modePrefix+'humidity'),
    hidden: isHidden('humidity')
  },
  {
    dataField: 'PMI1',
    text: formatMessage(modePrefix+'pmi_1'),
    hidden: isHidden('pmi_1')
  },
  {
    dataField: 'PMI25',
    text: formatMessage(modePrefix+'pmi_2_5'),
    hidden: isHidden('pmi_2_5'),
  },
  {
    dataField: 'PMI10',
    text: formatMessage(modePrefix+'pmi10'),
    hidden: isHidden('pmi10'),
  },
  {
    dataField: 'CO2',
    text: formatMessage(modePrefix+'co2'),
    hidden: isHidden('co2'),
  },
  {
    dataField: 'TVOC',
    text: formatMessage(modePrefix+'tvoc'),
    hidden: isHidden('tvoc'),
  },
  {
    dataField: 'CH2O',
    text: formatMessage(modePrefix+'ch2o'),
    hidden: isHidden('ch2o'),
  },
  {
    dataField: 'CO',
    text: formatMessage(modePrefix+'co'),
    hidden: isHidden('co'),
  },
];


  return (
    <React.Fragment>
      {
        props.showAddSensorColumnPopup &&
        <AddIAQSensorColumn
          from='SensorData'
          model={model}
          columnSave={onColumnSave}
          modalClosed={props.addSensorColumToggleHandler} />
      }

      {
        props.showDownloadSensorPopup &&
        <IAQSensordataDownloadSensor
          model={model}
          id={iccid}
          modalClosed={props.downloadSensorToggleHandler}
        />
      }

      <div className="icon-nav navbar-fixed-top device-nav-bar">
        <div className="container-fluid">
          <div className="filter-left-area">
            <ul>
              <li><h1><img src={sensorIcon} alt=""></img> <FormattedMessage id='Sensor_Data_Title' /></h1></li>
            </ul>
          </div>

          <div className="add-list float-right">
            <ul>
              <li title={formatMessage('Back')}>
                <a data-toggle="modal" onClick={() => backToSensorDataHandler()}>
                    <img src={backIcon} alt="back"></img>
                </a>
              </li>
              <li title={formatMessage('Add_Sesnor_Columns')}>
                <a data-toggle="modal" onClick={() => openAddColumn({ id: -1, iccid: '' }, false)} data-target="#addSensor">
                  <i className="material-icons">view_day</i>
                </a>
              </li>
              <li title={formatMessage('Download')}>
                <a data-toggle="modal" onClick={() => downloadSensorClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                  </svg>
                </a>
              </li>

              <li title={formatMessage('Chart')}>
                <a data-toggle="modal" onClick={() => gotoChartClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-graph-up" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z" />
                  </svg>
                </a>
              </li>
              <li title={formatMessage('Refresh')}>
                <a data-toggle="modal" onClick={() => refreshSensorDataClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                  </svg>
                </a>
              </li>
              <li className="page-number">
                <Pagination isRefreshPage={false} totalPages={pageInfo.totalPages} pageLimit={pager.pageLimit} onPageChanged={onPageChanged} disablePagination={disablePagination} setIsRefreshPage={setIsRefreshPage} />
              </li>
              <li className="page-count-no">
                <select className='pageLimit' onChange={onPageLimitChanged} value={pager.pageLimit}>
                  {pager.pageLimitOptions.map((op: any) => <option key={op} value={op}>{op}</option>)}
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-12 mb-3 data-heading" id="data-heading">
        <div className="d-md-flex">

          {/* <div className="mr-3 iccid-col">
              <h4>{formatMessage('Sensor_Table_Col_ICCID')}</h4>
              <h5>{sensorLocation.iccid}</h5>
          </div> */}
          
          <div className="mr-md-3 w-100">
              <h4>{formatMessage("iccid")}</h4>
              <h5>{iccid}</h5>
          </div>
          <div className="mr-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_CustomerId")}</h4>
              <h5>{sensorLocation.customerId}</h5>
          </div>
          <div className="mr-md-3 w-100">
              <h4>{formatMessage("Sensor_type")}</h4>
              <h5>{sensorLocation.model}</h5>
          </div>
          <div className="mx-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Building")}</h4>
              <h5>{sensorLocation.building}</h5>
          </div>
          <div className="mx-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Floor")}</h4>
              <h5>{sensorLocation.floor}</h5>
          </div>
          <div className="mx-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Room")}</h4>
              <h5>{sensorLocation.room}</h5>
          </div>
          <div className="ml-md-3 w-100">
              <h4>{formatMessage("Sensor_Table_Col_Location")}</h4>
              <h5>{sensorLocation.location}</h5>
          </div>
        </div>
      </div>


      <div className="device-detail">
        <div className="table-responsive" style={windowHeight}>
          {
          sensorDataList.loading && columnLists.loading ? <Loader /> : 
          (allSensorsData && allSensorsData.IAQSensorData.length > 0 ? <Grid data={allSensorsData.IAQSensorData} columns={iaqcolumns} keyField="Id" /> 
          :
          <NoDataComponent image={SensorIcon} imageAlt={'No Sensor Data'} message={'No_Sensor_Data'} />  
        )
          }
        </div>
      </div>

    </React.Fragment>
  )
};

export default injectIntl(AddIAQSensorColumnPopupHOC(DownloadSensorPopupHOC(IAQSensorData)));
